import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Skrivnosti",
  "description": "",
  "published": "2007-01-24T00:00:00.000Z",
  "redirect_from": ["/blog/skrivnosti/swizec/308"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Imate veliko skrivnost, ki vam otezuje zivljenje? Vas mogoce samo zanimajo skrivnosti, ki so jih bili drugi pripravljeni deliti z internetom? Sedaj greste lahko `}<a parentName="p" {...{
        "href": "http://postsecret.blogspot.com/"
      }}>{`semkaj`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      